/** 渲染单个图层的物料组件（编辑态 ctx）。未知物料时显示占位。 */
import { memo, useMemo } from 'react';
import type { Layer, MaterialContext } from '@h5/schema';
import { getMaterial } from '@h5/materials';
import { useEditorStore } from '../store/store';

const noop = () => {};

interface Props { layer: Layer; zoom: number }

export const LayerView = memo(function LayerView({ layer, zoom }: Props) {
  const updateLayerProps = useEditorStore((s) => s.updateLayerProps);
  const def = getMaterial(layer.type);

  const ctx = useMemo<MaterialContext>(() => ({
    mode: 'edit',
    layer,
    scale: zoom,
    nav: { gotoPage: noop, next: noop, prev: noop, openPopup: noop, closePopup: noop },
    dispatch: noop,
    api: { submitForm: async () => {} },
    assets: { url: (src) => src },
    updateProps: (patch) => updateLayerProps(layer.id, patch),
  }), [layer, zoom, updateLayerProps]);

  if (!def) {
    return (
      <div style={{ width: '100%', height: '100%', border: '1px dashed #f5222d', color: '#f5222d', fontSize: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', boxSizing: 'border-box' }}>
        未知物料: {layer.type}
      </div>
    );
  }
  const Comp = def.component;
  return <Comp props={layer.props} ctx={ctx} />;
});
